import React from 'react'

export const ComponentImagenologyProfile = () => {
  return (
    <div>ComponentImagenologyProfile</div>
  )
}
